module.exports = __FOREMAN_VENDOR__REGENERATOR_RUNTIME_RUNTIME__;